import React, { useState, useContext, useEffect } from 'react';
import { useParams } from 'react-router-dom';

import UserContext from './user.jsx';

import files_api from '../api/files.js';

const FilesContext = React.createContext();

function FilesProvider({ children }) {
	const [files, files_set] = useState([]);
	const { session } = useContext(UserContext);
	const { app_uid } = useParams();

	const store = {
		get list() {
			return files;
		},
		async add(...files) {
			await Promise.all(files.map((file) => files_api.upload({ file, session, app_uid })));
			await update_files();
		},
		async remove(name) {
			await files_api.delete({ name, session, app_uid });
			await update_files();
		},
	};

	const update_files = async () => {
		if(!app_uid || !session) return;
		files_set(await files_api.list({ session, app_uid }));
	};

	useEffect(() => {
		update_files();
	}, [app_uid, session]);

	return <FilesContext.Provider value={store}>{children}</FilesContext.Provider>;
}

export default FilesContext;
export { FilesProvider };
